import React from 'react'

const MediaLikesIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.59712 3.49772C3.27368 2.82136 4.19117 2.44141 5.14782 2.44141C6.10448 2.44141 7.02197 2.82136 7.69853 3.49772C7.83081 3.62952 8.0011 3.79355 8.20939 3.98982C8.4172 3.79355 8.58724 3.62952 8.71953 3.49772C9.39325 2.82715 10.3044 2.44957 11.255 2.44703C12.2055 2.44448 13.1187 2.81718 13.796 3.48412C14.4733 4.15107 14.86 5.05836 14.8721 6.00884C14.8842 6.95932 14.5207 7.87618 13.8606 8.56016L8.71881 13.702C8.5835 13.8372 8.4 13.9132 8.20867 13.9132C8.01734 13.9132 7.83384 13.8372 7.69853 13.702L2.55671 8.56088C1.89724 7.88074 1.53175 6.9685 1.53917 6.02117C1.5466 5.07383 1.92707 4.16743 2.59712 3.49772Z" fill="white" />
        </svg>
    )
}

export default MediaLikesIcon